import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Button, Dropdown, Modal } from "semantic-ui-react";

import dataHandler from "@Utils/dataHandler";

import styles from "./styles.module.css";

const CallTransferModal = ({ dispatch, open, onClose, onTransfer }) => {
	const [users, setUsers] = useState([]);
	const [groups, setGroups] = useState([]);
	const [targetType, setTargetType] = useState("user");
	const [targetId, setTargetId] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!open) return;
		let active = true;
		Promise.all([
			dataHandler({
				dispatch,
				url: "/companyUsers/transfer",
				params: { page: 1, rows: 100, orderKey: "user.fullName", orderDir: "asc", state: "En Línea" },
			}),
			dataHandler({
				dispatch,
				url: "groups",
				params: { page: 1, rows: 100, orderKey: "name", orderDir: "asc" },
			}),
		]).then(([userResponse, groupResponse]) => {
			if (!active) return;
			setUsers(userResponse?.items || []);
			setGroups(groupResponse?.items || []);
		});
		return () => {
			active = false;
		};
	}, [dispatch, open]);

	const options = useMemo(() => {
		if (targetType === "group") {
			return groups.map((group) => {
				return { key: group.id, value: group.id, text: group.name };
			});
		}
		return users.map((item) => {
			return {
				key: item.userId,
				value: item.userId,
				text: item.user?.fullName || item.fullName || item.userName,
			};
		});
	}, [groups, targetType, users]);

	const submit = async () => {
		if (!targetId) return;
		setLoading(true);
		const success = await onTransfer({
			userId: targetType === "user" ? targetId : null,
			groupId: targetType === "group" ? targetId : null,
		});
		setLoading(false);
		if (success) {
			setTargetId(null);
			onClose();
		}
	};

	return (
		<Modal open={open} onClose={onClose} size="tiny" closeIcon>
			<Modal.Header>Transferir llamada</Modal.Header>
			<Modal.Content className={styles.content}>
				<Dropdown
					selection
					fluid
					value={targetType}
					options={[
						{ key: "user", value: "user", text: "Agente en línea" },
						{ key: "group", value: "group", text: "Grupo" },
					]}
					onChange={(event, data) => {
						setTargetType(data.value);
						setTargetId(null);
					}}
				/>
				<Dropdown
					selection
					search
					fluid
					placeholder={targetType === "user" ? "Seleccionar agente" : "Seleccionar grupo"}
					value={targetId}
					options={options}
					onChange={(event, data) => {
						return setTargetId(data.value);
					}}
				/>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose}>Cancelar</Button>
				<Button primary loading={loading} disabled={!targetId || loading} onClick={submit}>
					Transferir
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

CallTransferModal.propTypes = {
	dispatch: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onTransfer: PropTypes.func.isRequired,
};

export default CallTransferModal;
